import { FormData, SetFormData } from "./FormData.tsx";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import amenities from "../../../assets/Amenities.tsx";

interface listingForm {
  formData: FormData;
  setFormData: SetFormData;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

interface workspaceAmenities {
  id: number;
  name: string;
  category: string;
  description?: string;
  iconLibrary?: string; // Optional, if the icon is from a library
  iconName?: string; // Optional, if the icon is from a library
  image?: React.ComponentType<{ className?: string }>;
}

export default function WorkplaceAmenities({
  formData,
  setFormData,
  setNextDisabled,
}: listingForm) {
  const [workspaceAmenities, setworkspaceAmenities] = useState<
    workspaceAmenities[]
  >([]);

  useEffect(() => {
    const fetchWorkspaceAmenities = async () => {
      try {
        const token = Cookies.get("authToken");
        const response = await axios.get<workspaceAmenities[]>(
          "/api/WorkspaceAmenities/ListAmenities",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setworkspaceAmenities(response.data);
        console.log("Fetched workspace types:", response.data);
      } catch (err) {
        console.error("Error fetching workspace types:", err);
      }
    };

    fetchWorkspaceAmenities();
  }, []);
  // Function to handle input change and update form data
  const handleInputChange = (value: number) => {
    setFormData((prev) => {
      // Create a copy of the current amenities array or initialize it if empty
      const currentAmenities = prev.workspaceAmenities || [];

      // Check if the value is already selected
      const isSelected = currentAmenities.includes(value);

      // Toggle the selection
      const updatedAmenities = isSelected
        ? currentAmenities.filter((v) => v !== value) // Remove if already selected
        : [...currentAmenities, value]; // Add if not selected

      return {
        ...prev,
        workspaceAmenities: updatedAmenities,
      };
    });
  };

  // Check if at least one amenity is selected
  useEffect(() => {
    if (formData.workspaceAmenities && formData.workspaceAmenities.length > 0) {
      setNextDisabled(false);
    } else {
      setNextDisabled(true);
    }
  }, [formData.workspaceAmenities, setNextDisabled]);

  return (
    <div className="space-y-4">
      <h2 className="text-3xl font-bold mb-4">
        What amenities does your workspace provide?
      </h2>
      <hr className="border-t border-gray-500 my-4 w-full shadow-gray-400" />
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 my-2">
        {workspaceAmenities.map((amenity) => {
          const IconElement =
            amenities.find((type) => type.value === amenity.id)?.icon || null;
          return (
            <div
              key={amenity.id}
              onClick={() => handleInputChange(amenity.id)}
              className={`p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 ${
                formData.workspaceAmenities?.includes(amenity.id)
                  ? "outline outline-2 outline-black bg-gray-200"
                  : ""
              }`}
            >
              <div className="flex items-center gap-3">
                {IconElement && (
                  <span className="h-6 w-6 mr-3"><IconElement className="h-6 w-6" /></span>
                )}
                <h3 className="text-lg font-medium">{amenity.name}</h3>
                <p className="mt-2 text-sm text-gray-500 hidden group-hover:block">
                  {amenity.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
